/**
 * Central RSVP labels for guest-facing surfaces (chips: `components/ui/event-status-pill`).
 * Source of truth for attendance choice is server `EventData.rsvpStatus` (`rsvps` table);
 * timeline/local RSVP is fallback only (see {@link resolveAttendingTabRsvp}).
 */

import type { PersistedRsvpStatus } from "@/lib/events/types"
import type { RsvpStatus } from "@/lib/timeline-store"

/** Short label for list chips (Going / Maybe / Declined). */
export function attendingRsvpShortLabel(status: RsvpStatus): string | null {
  if (status === "going") return "Going"
  if (status === "maybe") return "Maybe"
  if (status === "not_going") return "Declined"
  return null
}

/** One-line hero summary for signed-in guests who have an RSVP. */
export function guestRsvpHeroSummary(
  status: PersistedRsvpStatus | null | undefined,
): string | null {
  if (status === "going") return "Your RSVP: Going"
  if (status === "maybe") return "Your RSVP: Maybe"
  if (status === "declined") return "Your RSVP: Declined"
  return null
}
